import React from 'react';
import { Header } from './Header';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  return (
    <div className="flex flex-col h-screen">
      <Header />
      <div className="pt-16 flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
